jQuery( document ).ready(function($) { 
  /* SlimMenu Prep */
  $('#navigation').slimmenu({
    resizeWidth: '4000',
    collapserTitle: '',
    animSpeed: 0,
    easingEffect: null,
    indentChildren: false,
    childrenIndenter: '&nbsp;',
    expandIcon: '',
    collapseIcon: ''
  });
  /* add mobile to body classes */
  if($('#is-on-mobile').is(':visible')) {
    document.body.classList.add("on-mobile");
  } else {
    document.body.classList.add("not-on-mobile");
  }
  /* share button */
  $('.socialShare').each(function() {
    $(this).click(function() {
      if($('.share-buttons').css('display') == 'block') {
        $('.share-buttons').css('display','none');
      } else {
        $('.share-buttons').css('display','block');
      }
    });
  });
});

jQuery( document ).ready(function($) {
  $(document).ready(function() {
    $('#rowan-menu-button').click(function() {
      if($('#rowan-menu').hasClass('d-none')) {
        $('#rowan-menu').removeClass('d-none');
        $('#rowan-links').addClass('hidethis');
        $('#parent-portal').addClass('hidethis');
        $('#rowan-menu-text').text('CLOSE');
      }
      else {
        $('#rowan-menu').addClass('d-none');
        $('#rowan-links').removeClass('hidethis');
        $('#parent-portal').removeClass('hidethis');
        $('#rowan-menu-text').text('MENU');
      }
    });
    $('.rowan-menu-open-level2').click(function() {
      if($(this).parent().find('.rowan-menu-level2').css('display') == 'none') {
        $(this).find('.fa-plus-square').removeClass('fa-plus-square').addClass('fa-minus-square');
        $(this).parent().find('.rowan-menu-level2').css('display','block');
      } else {
        $(this).find('.fa-minus-square').removeClass('fa-minus-square').addClass('fa-plus-square');
        $(this).parent().find('.rowan-menu-level2').css('display','none');
      }
    });
  });
});



document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages;    
  if ("IntersectionObserver" in window) {
    // scroll detection
    var scrollObserver = new IntersectionObserver(function(entries, observer) {
      if (entries[0].boundingClientRect.y < 0) {
        document.body.classList.add("header-not-at-top");
      } else {
        document.body.classList.remove("header-not-at-top");
      }
    });
    scrollObserver.observe(document.querySelector("#top-of-site-pixel-anchor"));

    // lazy load images
    lazyloadImages = document.querySelectorAll(".lazyload");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          if(image.classList.contains("lazyloadbackground")) {
            image.style.backgroundImage = "url('" + image.dataset.src + "')";
            console.log("Observer lazy loaded a background - " + image.dataset.src);
          } else {
            image.src = image.dataset.src;
            console.log("Observer lazy loaded an image - " + image.dataset.src);
          }
          image.classList.remove("lazyload");
          imageObserver.unobserve(image);
        }
      });
    });
    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  } else {  
    // no browser support, just load everything (IE 11 etc.)
    var llImages = document.getElementsByClassName('lazyload');
    for (var i = 0; i < llImages.length; ++i) {
      var llImg = llImages[i];
      if(llImg.classList.contains('lazyloadbackground')) {
        llImg.style.backgroundImage = "url('" + llImg.dataset.src + "')";
      } else {
        llImg.src = llImg.dataset.src;
      }
      llImg.classList.remove('lazyload');
    }
  }
});

